import React from 'react';
import proptypes from 'prop-types';
const { string, bool, func } = proptypes;
import { useConfigService } from '@thd-nucleus/experience-context';
import { isFunction } from '../../../components/helper/utils';
import { InStockIcon, UnavailableIcon, AtYourStoreIcon } from '../../helpers/icon-utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';
import { PodMessage } from '../PodMessage';

const LiveGoodsPod = ({
  storeName = null, seasonStatusEligible = false, customRender = null, isNewFulfillmentPodMessagingEnabled = false, isNarrowPod = false
}) => {
  const enablePLPFasterDeliveryOption = !!useConfigService('fs:enablePLPFasterDeliveryOption');
  const inSeasonIcon = enablePLPFasterDeliveryOption ? AtYourStoreIcon : InStockIcon;
  const iconSelector = seasonStatusEligible ? inSeasonIcon : UnavailableIcon;
  const pickupType = (seasonStatusEligible || !isNewFulfillmentPodMessagingEnabled) ? 'At Your Store' : 'Pickup';
  const seasonMessage = seasonStatusEligible ? 'In Season' : 'Out of Season';
  const seasonMessageStyle = seasonStatusEligible ? 'sui-text-success' : 'sui-text-subtle';
  const atMessageStyle = seasonStatusEligible ? 'sui-text-primary' : 'sui-text-subtle';

  if (isFunction(customRender)) {
    return customRender(
      {
        icon: iconSelector,
        pickUpTemplate: PICKUP_TEMPLATES.LIVE_GOODS_POD,
        values: { pickupType, storeName, message: seasonMessage }
      });
  }

  return (
    <PodMessage
      messageIcon={iconSelector}
      messageType={pickupType}
      isStoreNameAtEnd={isNewFulfillmentPodMessagingEnabled}
      isNarrowPod={isNarrowPod}
    >
      <>
        <span className={seasonMessageStyle}>{seasonMessage}</span>
        {storeName && (<> <span className={atMessageStyle}>at </span>{storeName}</>)}
      </>
    </PodMessage>
  );
};

LiveGoodsPod.propTypes = {
  storeName: string,
  seasonStatusEligible: bool,
  customRender: func,
  isNewFulfillmentPodMessagingEnabled: bool,
  isNarrowPod: bool
};

export { LiveGoodsPod };
